import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Hint } from '@utex/ui-kit';
import { ErrorMessage } from '@unitedtraders/microfrontend-common/dist/utils/restErrorToForm';

interface Props {
  children: ErrorMessage | null | undefined;
}

// t('exception:Insufficient funds on account={accountId}, required={amount}, but actual={actual}')
// t('exception:Money value should be more than 0')
// t('exception:Temporarily unsupported')

export const FormError: React.FC<Props> = ({ children: error }) => {
  const { t, i18n } = useTranslation('exception');

  if (!error) {
    return null;
  }

  console.log(error.message);

  const text = i18n.exists(error.message, { ns: 'exception' })
    ? t(error.message, error.details)
    : t('common-error');

  return (
    <Box marginTop={10}>
      <Hint view="error" textAlign="center">
        {text}
      </Hint>
    </Box>
  );
};
